angular.module("Main").filter("checkIfOnlineMandant", function () {
    return function(input, mandantId, options) {
        var result = 1;
        if(!_.isUndefined(mandantId)) {
            var findSurvey = _.find(options, {
                'Mandant_Nr': mandantId
            });
            if (findSurvey && !_.isUndefined(findSurvey)) {
                result = findSurvey.Online;
            }
        }
        return result;
    };
});